module.exports = __webpack_public_path__ + "img/usa.6e0defcf.svg";